export const nbNO = {
  app: {
    categories: {
      convectors: 'Konvektorer',
      decorative: 'Design',
      electric: 'Elektrisk ',
      panels: 'Paneler',
      towel: 'Håndklevarmere',
    },
    categoryLabel: 'Kategori',
    categoryPlaceholder: 'Velg en kategori',
    errorCategories: 'Kunne ikke hente kategoriene.',
    errorPanels: 'Kunne ikke laste radiatorer.',
    loadingCategories: 'Laster inn kategorier...',
    loadingPanels: 'Laster radiatorer...',
    panelLabel: 'Radiatorer',
    panelPlaceholder: 'Velg en radiator',
    titles: {
      convectors: 'Kalkulator for konvektorer',
      decorative: 'Kalkulator for designerradiatorer',
      electric: 'Elektrisk radiatorkalkulator',
      panels: 'Kalkulator for panelradiatorer',
      towel: 'Kalkulator for håndklevarmer',
    },
  },
  calc: {
    actionButton: 'Vis beregnede produkter',
    boost: 'Boost-modus',
    calculateRequiredButton: 'Beregn nødvendig effekt',
    calculating: 'Beregner...',
    comfort: 'Komfort-modus',
    downloadLabel: 'Last ned data ({count})',
    emptyResults: 'Ingen resultater ennå.',
    errorMatch: 'Kunne ikke beregne resultater.',
    errorTypes: 'Kunne ikke laste radiatortyper.',
    flowTemp: 'Tilførsel C°',
    height: 'Høyde',
    length: 'Lengde',
    loadingTypes: 'Laster typer...',
    modeLabel: 'Modus',
    modes: {
      cooling: 'Kjøling',
      heating: 'Oppvarming',
    },
    radiatorType: 'Radiatortype',
    requiredWatts: 'Nødvendig effekt (W)',
    resultsMessage: '{count} produkter tilgjengelig for valgte innstillinger.',
    returnTemp: 'Retur C°',
    roomTemp: 'Romtemperatur C°',
    selectAllLabel: 'Velg alle produkter',
    selectItemLabel: 'Velg produkt for nedlasting',
    selectPanel: 'Velg en radiator for å beregne.',
    standby: 'Standby-modus',
    tableHeaders: {
      calculatedWattage: 'Effekt',
      co2Equivalent: 'CO2-ekvivalent per kg materiale',
      depth: 'Dybde [mm]',
      description: 'Produktbeskrivelse',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Høyde [mm]',
      itemId: 'Varenummer',
      length: 'Lengde [mm]',
      waterContent: 'Vanninnhold',
      weight: 'Vekt',
    },
    title: 'Beregninger',
    tolerance: 'Toleranse',
    typeCooling: 'Kjøling',
    typeGroupLabel: 'Type',
    typeHeating: 'Oppvarming',
  },
  existingRadiator: {
    description:
      'Denne kalkulatoren er kun til informasjon. Rådfør deg alltid med en profesjonell installatør for nøyaktig beregning før du kjøper radiatoren.',
    height: 'Radiatorhøyde',
    length: 'Radiatorlengde',
    resultLabelTemplate: 'Varmeeffektbehov, beregnet ved {temp} systemtemperatur',
    select: 'Velg',
    temperature: 'Systemtemperatur',
    type: 'Radiatortype',
  },
  matrixCalc: {
    axisHeight: 'Høyde (mm)',
    axisLength: 'Lengde (mm)',
    axisType: 'Type',
    calculateButton: 'Calculate',
    displayLabel: 'Visning',
    exportExcel: 'Eksporter som Excel',
    exportPdf: 'Eksporter som PDF',
    print: 'Skriv ut',
    hideOutOfRange: 'Skjul varer utenfor området',
    showAll: 'Vis alle',
    loading: 'Loading...',
    lockHeight: 'Høyde',
    lockLabel: 'Lås dimensjon',
    lockLength: 'Lengde',
    lockType: 'Type',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Beregn',
    clearButton: 'Tøm alt',
    fields: {
      ceilingHeight: 'Takhøyde',
      doorInsulation: 'Dørisolasjon',
      floorInsulation: 'Gulvisolasjon',
      glazingArea: 'Glassareal',
      glazingMode: 'Glassareal',
      glazingQuality: 'Glasskvalitet',
      length: 'Lengde',
      outerWalls: 'Yttervegger',
      projectedDesignTemp: 'Dimensjonerende utetemperatur',
      roofInsulation: 'Takisolasjon',
      roomArea: 'Romareal',
      roomFloor: 'Etasje',
      roomInsulation: 'Romisolasjon',
      roomPreset: 'Romtype',
      roomTemperature: 'Romtemperatur',
      roomType: 'Romtype',
      uncertaintyFactor: 'Usikkerhetsfaktor',
      ventilation: 'Ventilasjonsnivå',
      wallInsulation: 'Veggisolasjon',
      width: 'Bredde',
      windConditions: 'Vindforhold',
      windowInsulation: 'Vinduisolasjon',
    },
    intro:
      'Denne kalkulatoren er kun til informasjon. Rådfør deg alltid med en profesjonell installatør for nøyaktig beregning før du kjøper radiatoren.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mer enn 20%',
        low: 'Mindre enn 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Over 20%',
        below_10: 'Under 10%',
        from_10_to_20: 'Fra 10% til 20%',
        no_windows: 'Uten vinduer',
      },
      insulationValue: {
        good: 'God',
        medium: 'Middels',
        poor: 'Dårlig',
        very_good: 'Meget god',
      },
      qualityValue: {
        modern_excellent: 'Moderne, utmerket energieffektivitet',
        modern_good: 'Moderne, god energieffektivitet',
        old_poor: 'Gamle, svært dårlig energieffektivitet',
        traditional_medium: 'Tradisjonelle, middels energieffektivitet',
      },
      roomValue: {
        bathroom_24: 'Bad (24 C°)',
        bedroom_20: 'Soverom (20 C°)',
        garage_12: 'Garasje (12 C°)',
        livingroom_22: 'Stue (22 C°)',
        storage_16: 'Lager (16 C°)',
      },
      select: 'Velg',
      storeyValue: {
        ground_multi: 'Første etasje (fleretasjes bygning)',
        ground_single: 'Første etasje (enplans bygning)',
        interim: 'Mellometasje',
        top_multi: 'Øverste etasje (fleretasjes bygning)',
      },
      temp: {
        climate_zone_1: 'DUT -12 C°',
        climate_zone_2: 'DUT -14 C°',
        climate_zone_3: 'DUT -16 C°',
        climate_zone_4: 'DUT -18 C°',
        climate_zone_5: 'DUT -20 C°',
        climate_zone_6: 'DUT -22 C°',
        climate_zone_7: 'DUT -24 C°',
        climate_zone_8: 'DUT -26 C°',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Sterk',
        weak: 'Svak',
      },
    },
    roomPresets: {
      bathroom: 'Bad',
      bedroom: 'Soverom',
      garage: 'Garasje',
      kitchen: 'Kjøkken',
      living: 'Stue',
      storage: 'Lager',
    },
    sections: {
      dimensions: 'Romdimensjoner',
      insulation: 'Isolasjon',
      placement: 'Plassering',
      result: 'Resultat',
      temps: 'Temperaturer',
      ventilation: 'Ventilasjon',
    },
    title: 'Romvarmetaps-kalkulator',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Bruk',
  },
  slider: {
    from: 'Fra',
    to: 'Til',
    value: 'Verdi',
  },
}
